import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { WindowRefService } from '../services/window.service';

/**
 * Redirect external URL
 *
 * In router:
 * {
 *	path: 'PATH_NAME',
 *	component: ANY_EXISTING_COMPONENT, // Random component
 *	resolve: {
 *		url: ExternalUrlRedirectResolver
 *	}
 *  data: {
 *		externalUrl: EXTERNAL_URL // Not necessary if external URL is set via parameter
 *  }
 * }
 *
 * In service or component:
 *
 * constructor(protected router: Router);
 * ...
 * this.router.navigate(['/FULL_PATH_NAME', {externalUrl: EXTERNAL_URL}], {
 *				skipLocationChange: true,
 * });
 *
 */
@Injectable({
	providedIn: 'root'
})
export class ExternalUrlRedirectResolver implements Resolve<Observable<string>> {
	/**
	 * Constructor
	 *
	 * @param windowRef
	 */
	constructor(protected windowRef: WindowRefService, protected logger: LoggerService) {}

	/**
	 * Resolve function
	 *
	 * @return
	 */
	resolve(route: ActivatedRouteSnapshot) {
		// Get external URL
		const externalRouteViaParam = route.paramMap.get('externalUrl');
		const externalUrl = externalRouteViaParam ? externalRouteViaParam : route.data.externalUrl;

		// Check external URL
		if (!externalUrl || externalUrl.length <= 0) {
			this.logger.error('Missing externalUrl in route params or data');
			return false;
		}

		// Get target
		const targetViaParam = route.paramMap.get('target');
		const target = targetViaParam ? targetViaParam : route.data.target;

		// Redirect
		if (target && target.length > 0) {
			return this.windowRef.nativeWindow.open(externalUrl, target);
		} else {
			return (this.windowRef.nativeWindow.location.href = externalUrl);
		}
	}
}
